import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/search-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6a8bc46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  for: "search",
  class: "search-label"
}
const _hoisted_2 = { class: "search-input-wrapper" }
const _hoisted_3 = ["onKeypress"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Search Icon"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, watch } from 'vue';
import debounce from 'lodash.debounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    initialQuery: {}
  },
  emits: ['update:query', 'search'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const query = ref(props.initialQuery);

watch(
  () => props.initialQuery,
  (newQuery) => {
    query.value = newQuery;
  },
  { immediate: true },
);

const onSearch = () => {
  emits('update:query', query.value);
  emits('search', query.value);
};

const debouncedSearch = debounce(() => {
  emits('update:query', query.value);
  emits('search', query.value);
}, 300);

watch(query, debouncedSearch);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "search-container",
    onSubmit: _withModifiers(onSearch, ["prevent"])
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          id: "search",
          type: "text",
          class: "search-input",
          placeholder: "Search"
        }, null, 512), [
          [_vModelText, query.value]
        ]),
        _createElementVNode("span", {
          class: "search-icon",
          onKeypress: _withKeys(_withModifiers(onSearch, ["prevent"]), ["enter"]),
          onClick: onSearch
        }, _hoisted_5, 40, _hoisted_3)
      ])
    ])
  ], 32))
}
}

})